module.exports = __webpack_public_path__ + "MagicandStitchcraft.webp?14fe4575371f2d3fffeebf0d96fe3cd7";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MagicandStitchcraft.webp
// module id = 133
// module chunks = 0